import { useMutation } from "@tanstack/react-query";
import { getCommunicationVehiclesForExport } from "../services";
import type { CommunicationExportParams, CommunicationVehicle } from "../types";

export function useExportCommunication() {
	return useMutation<CommunicationVehicle[], Error, CommunicationExportParams>({
		mutationFn: (params) => getCommunicationVehiclesForExport(params),
	});
}
